export class DateFilterDto {
  startDate?: Date
  endDate?: Date
  status?: string

  static create() {
    return new DateFilterDto()
  }
}
